<template>
  <article>
    <section class="xbed-sub-title">
      <span>关联管理</span>
    </section>

    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>渠道列表</BreadcrumbItem>
        <BreadcrumbItem>关联管理：{{title}}</BreadcrumbItem>
      </Breadcrumb>
    </section>

    <Tabs class="tabs" @on-click="toggleTab" style="margin-top: 20px">
        <TabPane label="门店列表" name="hotelList" ref="hotelList">
          <Form @submit.native.prevent="preventSubmit" :model="hotelList.form" inline>
            <FormItem prop="hotel" label="xbed门店：" :label-width="90">
              <Input type="text" v-model="hotelList.form.hotel" placeholder="请输入查询关键字"></Input>
            </FormItem>
            <FormItem prop="keyword" label="查询：" :label-width="60">
              <Input type="text" v-model="hotelList.form.keyword" placeholder="请输入查询关键字"></Input>
            </FormItem>
            <FormItem prop="hotelQuery">
              <Button type="primary">查询</Button>
            </FormItem>
            <FormItem prop="addHotel">
              <Button type="primary" @click="openModal">新增门店匹配</Button>
            </FormItem>
          </Form>
          <Table stripe class="tableList" :loading="hotelList.loading" height="450" :columns="hotelList.columns" :data="hotelList.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="hotelList.count" :current="hotelList.page" :page-size="hotelList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </TabPane>
        <TabPane label="渠道房型" name="roomTypeList" ref="roomTypeList" style="margin-left: 1px">
          <Form @submit.native.prevent="preventSubmit" :model="roomTypeList.form" inline>
            <FormItem prop="dockingStatus" label="筛选打包状态：" :label-width="110">
              <Select v-model="roomTypeList.form.dockingStatus" filterable>
                <Option value="S00">全部</Option>
                <Option value="1">已打包</Option>
                <Option value="0">未打包</Option>
              </Select>
            </FormItem>
            <FormItem prop="hotel" label="所属门店：" :label-width="90">
              <Input type="text" v-model="roomTypeList.form.hotel" placeholder="请输入门店名称"></Input>
            </FormItem>
            <FormItem prop="roomTypeQuery">
              <Button type="primary">查询</Button>
            </FormItem>
          </Form>
          <Table stripe :loading="roomTypeList.loading" height="450" :columns="roomTypeList.columns" :data="roomTypeList.data"></Table>
          <div style="float: left;margin: 10px;overflow: hidden">
            <Page show-sizer placement="top" :total="roomTypeList.count" :current="roomTypeList.page" :page-size="roomTypeList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
          </div>
        </TabPane>
      </Tabs>

      <Modal v-model="addHotel.display" ref="addHotelModal" :loading="true" :width="1000" title="xbed门店列表" @on-ok="prepareAddHotel" @on-cancel="cancelAddHotel" ok-text="新增" cancel-text="关闭">
        <Form @submit.native.prevent="preventSubmit" v-model="addHotel.form" inline>
          <FormItem  label="省市：" prop="city" :label-width="60">
            <Cascader v-model="addHotel.form.city" :data="provCityList" :load-data="queryHotelCities" :transfer="true"></Cascader>
          </FormItem>
          <FormItem prop="modalQuery">
            <Button type="primary" @click="queryHotelListWithUnbind">查询</Button>
          </FormItem>
          <FormItem v-if="addHotel.data.length>0" style="float: right;" label="查询：" prop="modalKeyWord" :label-width="60">
            <Input type="text" v-model="addHotel.form.keyword"  @on-enter="queryAddHotelDataWithKeyword" @on-change="queryAddHotelDataWithKeyword" placeholder="查询关键字"></Input>
          </FormItem>
        </Form>
        <Table stripe highlight-row :loading="addHotel.loading" :columns="addHotel.columns" :data="addHotel.displayData" @on-current-change="changeSelectedHotel"></Table>
        <div style="margin: 10px;margin-bottom: 40px;overflow: hidden">
          <Page placement="top" :total="addHotel.count" :current="addHotel.page" @on-change="changeAddHotelListPage"></Page>
        </div>
        <template v-if="addHotel.selectedHotel.chainId">
          <Row>
            <Col span="3" class-name="text-align-center">已选门店ID</Col>
            <Col span="8" offset="1">{{ addHotel.selectedHotel.chainId }}</Col>
          </Row>
          <br>
          <Row>
            <Col span="3" class-name="text-align-center">已选门店名称</Col>
            <Col span="8" offset="1">{{ addHotel.selectedHotel.chainName }}</Col>
          </Row>
          <br>
          <Row type="flex" align="middle">
            <Col span="3" class-name="text-align-center">艺龙门店名称</Col>
            <Col span="8" offset="1">
              <Input type="text" v-model="hotelList.elongName" placeholder="请输入艺龙门店名称"></Input>
            </Col>
          </Row>
        </template>
      </Modal>

  </article>
</template>

<script>
import Utils from "../../utils";
import API from "../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });

    this.queryHotelProvinces();
    this.toggleTab(this.currTabName);
  },
  data() {
    return {
      channelId: 4,
      title: "渠道门店",
      currTabName: "hotelList",
      provCityList: [],
      hotelList: {
        title: '渠道门店',
        form: {
          hotel: '',
          keyword: '',
        },
        loading: false,
        columns: [
          {
            title: "渠道门店ID",
            key: "channelHotelId",
            align: "center",
            width: 180
          },
          {
            title: "渠道门店名称",
            key: "channelHotelName",
            align: "center",
            width: 200
          },
          {
            title: "xbed门店",
            key: "xbedHotelName",
            align: "center",
            width: 300
          },
          // {
          //   title: "所属热点",
          //   key: "hotspot",
          //   align: "center",
          //   width: 200
          // },
          {
            title: "操作",
            align: "center",
            width: 250,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        if(this.$router){
                          this.$router.push({path: "elongChannelHotelDetail", query: { hotelId: params.row.channelHotelId }});
                        }else{
                          window.open(`#/Ota/Ota/elongChannelHotelDetail?hotelId=${params.row.channelHotelId}`);
                        }
                      }
                    }
                  },
                  "查看详情"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "info",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        // window.open(`#/Ota/Ota/xbedChannelRoomTypeDetail?roomTypeId=${params.row.xbedRoomTypeId}`);
                      }
                    }
                  },
                  "房价房态"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    style: {
                      margin: "5px"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定删除该门店？`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          okText: "确定删除",
                          onOk: () => {
                            this.delHotel(params.index);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      roomTypeList: {
        title: '渠道房型',
        form: {
          dockingStatus: 'S00',
          hotel: '',
        },
        loading: false,
        columns: [
          {
            title: "房型ID",
            key: "xbedRoomTypeId",
            align: "center",
            width: 180
          },
          {
            title: "房型名称",
            key: "xbedRoomTypeName",
            align: "center",
            width: 200
          },
          {
            title: "所属门店",
            key: "xbedHotelName",
            align: "center",
            width: 200
          },
          {
            title: "打包数量",
            key: "dockingCount",
            align: "center",
            width: 180
          },
          {
            title: "缓冲房量",
            key: "bufferCount",
            align: "center",
            width: 180,
            render: (h) => {
              return h("div", {}, 0);
            }
          },
          {
            title: "操作",
            align: "center",
            width: 200,
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    style: {
                      marginRight: "10px"
                    },
                    on: {
                      click: () => {
                        if(this.$router){
                          this.$router.push({path: "elongChannelRoomTypeDetail", query: { roomTypeId: params.row.xbedRoomTypeId }});
                        }else{
                          window.open(`#/Ota/Ota/elongChannelRoomTypeDetail?roomTypeId=${params.row.xbedRoomTypeId}`);
                        }
                      }
                    }
                  },
                  "编辑打包"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          render: modalH => {
                            let modalText = `确定删除该房型？`;
                            return modalH(
                              "div",
                              {
                                style: {
                                  fontSize: "16px"
                                }
                              },
                              modalText
                            );
                          },
                          okText: "确定删除",
                          onOk: () => {
                            this.removeRoomType(params.index);
                          }
                        });
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      },
      addHotel: {
        display: false,
        loading: false,
        form: {
          city: [],
          keyword: ''
        },
        columns: [
          {
            title: "xbed门店id",
            key: "chainId",
            align: "center",
            width: 150,
            fixed: 'left'
          },
          {
            title: "xbed门店名称",
            key: "chainName",
            align: "center",
            width: 200
          },
          {
            title: "省份",
            key: "province",
            align: "center",
            width: 100
          },
          {
            title: "城市",
            key: "city",
            align: "center",
            width: 200
          },
          // {
          //   title: "热点名称",
          //   key: "hotspotName",
          //   align: "center",
          //   width: 250
          // },
          {
            title: "类型",
            key: "type",
            align: "center",
            width: 200,
            render: (h, params) => {
              let status = params.row.chainType == 0 ? "分散" : "聚集"
              return h("div", {}, status);
            }
          }
        ],
        data: [],
        filterData: [],
        displayData: [],
        selectedHotel: {},
        elongName: '',
        count: 0,
        pageCount: 0,
        page: 1,
        pageSize: 10,
      }
    }
  },
  methods: {
    toggleTab(tabName) {
      this.currTabName = tabName;
      this.title = this[tabName].title;
      this[tabName].page = 1;

      this.queryOtaList();
    },
    // 阻止form回车提交事件
    preventSubmit() {
      return false;
    },
    changePage(pageIndex) {
      this[this.currTabName].page = pageIndex;
    },
    changePageSize(pageSize) {
      this[this.currTabName].page = 1;
      this[this.currTabName].pageSize = pageSize;
    },
    queryOtaList() {
      if (this.currTabName == "hotelList") {
        this.queryHotelList();
      } else if (this.currTabName == "roomTypeList") {
        this.queryAllRoomTypeList();
      }
    },
    async queryHotelList() {
      this.hotelList.loading = true;
      let resp = (await this.sendQueryHotelList(
        this.hotelList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }

      this.hotelList.data = resp.result;
      this.hotelList.page = resp.page;
      this.hotelList.count = resp.count;
      this.hotelList.loading = false;
    },
    sendQueryHotelList(hotelList, token, env) {
      return API.omsAPI[env].ota.queryHotelList(
        this.channelId,
        '',
        hotelList.page,
        hotelList.pageSize,
        '',
        hotelList.form.hotel,
        token
      );
    },
    async queryAllRoomTypeList() {
      this.roomTypeList.loading = true;
      let resp = (await this.sendQueryAllRoomTypeList(
        this.roomTypeList,
        this.token,
        this.env
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }

      this.roomTypeList.data = resp.list;
      this.roomTypeList.page = resp.page;
      this.roomTypeList.count = resp.rowCount;
      this.roomTypeList.loading = false;
    },
    sendQueryAllRoomTypeList(roomTypeList, token, env) {
      let dockingStatus = this.roomTypeList.form.dockingStatus=="S00" ? "" : this.roomTypeList.form.dockingStatus;
      return API.omsAPI[env].ota.queryAllRoomTypeList(
        this.channelId,
        dockingStatus,
        this.roomTypeList.form.hotel,
        '',
        roomTypeList.page,
        roomTypeList.pageSize,
        token
      );
    },
    // 删除门店
    async delHotel(index) {
      let hotel = this.hotelList.data[index];

      // TODO: 接口有修改
      let resp = (await API.omsAPI[this.env].ota.removeHotel(
        hotel.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除门店成功"
        });

        this.hotelList.data.splice(index, 1);
        this.queryHotelList();
      }
    },
    // 删除房型
    async removeRoomType(index) {
      let roomType = this.roomTypeList.data[index];

      let resp = (await API.omsAPI[this.env].ota.removeRoomType(
        this.channelId,
        this.username,
        roomType.xbedRoomTypeId,
        roomType.xbedHotelId,
        this.token
      )).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "删除房型失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "删除房型成功"
        });

        this.roomTypeList.data.splice(index, 1);
        this.queryAllRoomTypeList();
      }
    },
    openModal() {
      this.addHotel.display = true;
    },
    async queryHotelCities(item, callback) {
      item.loading = true;
      let resp = (await API.omsAPI[this.env].ota.queryHotelCities(
        this.channelId,
        item.value,
        this.token
      )).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }
      resp.forEach(city => {
        city.label = city.city;
        city.value = city.city;
      })
      item.children = resp;
      item.loading = false;
      callback();
    },
    changeAddHotelListPage(pageIndex) {
      this.addHotel.page = pageIndex;
      this.queryHotelListWithUnbind();
    },
    async queryHotelListWithUnbind() {
      if (this.addHotel.form.city.length==0) {
        this.$Notice.error({
          title: "查询门店失败",
          desc: "请选择省市"
        });
        return;
      }
      this.addHotel.loading = true;
      let resp = (await this.sendHotelListWithUnbind(this.addHotel.form, this.token, this.env)).data;
      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
      }

      resp.forEach(hotel => {
        hotel.chainType = hotel.chainType == 0 ? "分散" : "聚集";
      })
      this.addHotel.data = resp;
      this.addHotel.count = resp.length;
      this.addHotel.pageCount = (this.addHotel.count % this.addHotel.page) == 0 ? (this.addHotel.count / this.addHotel.page) : (this.addHotel.count / this.addHotel.page + 1)
      this.addHotel.filterData = this.addHotel.data;
      this.displayUnbindHotelList();
      this.addHotel.loading = false;
    },
    sendHotelListWithUnbind(form, token, env) {
      return API.omsAPI[env].ota.queryHotelListWithUnbind(
        this.channelId,
        form.city[1],
        form.city[0],
        token
      )
    },
    displayUnbindHotelList() {
      let startIndex = (this.addHotel.page-1) * this.addHotel.pageSize;
      let endIndex = this.addHotel.pageSize * this.addHotel.page;
      this.modalDisplayData = [];

      let filterData = [];
      for (let i=startIndex; i<endIndex; i++) {
        if (!this.addHotel.filterData[i]) break;
        filterData.push(this.addHotel.filterData[i]);
      }
      this.addHotel.displayData = filterData;

    },
    queryAddHotelDataWithKeyword() {
      this.addHotel.loading = true;
      this.addHotel.filterData = this.filterDataWithKeyword();
      this.addHotel.page = 1;
      this.addHotel.count = this.addHotel.filterData.length;
      this.addHotel.pageCount = (this.addHotel.count % this.addHotel.filterData.length) == 0 ? (this.addHotel.count / this.addHotel.filterData.length) : (this.addHotel.count / this.addHotel.filterData.length + 1)
      this.displayUnbindHotelList();
      this.addHotel.loading = false;
    },
    filterDataWithKeyword() {
      return this.addHotel.data.filter((hotel) => {
        let result = false;
        for (let itemKey in hotel) {
          if (this.skipKeyFromData(itemKey)) {
            continue;
          }
          let queryItem = '' + hotel[itemKey];
          if (queryItem.toUpperCase().indexOf((this.addHotel.form.keyword).toUpperCase()) !== -1) {
            result = true;
            break;
          }
        }
        return result;
      });
    },
    skipKeyFromData(key) {
      let isSkip = false;
      switch(key) {
        case 'address':
        case 'contactName':
        case 'contactPhone':
        case 'remind':
        case 'hotspotId':
          isSkip = true;
          break;
      }
      return isSkip;
    },
    changeSelectedHotel(currHotel) {
      this.addHotel.selectedHotel = currHotel;
    },
    async prepareAddHotel() {
      if (Object.keys(this.addHotel.selectedHotel).length == 0) {
        this.$Notice.error({
          title: "添加门店失败",
          desc: "未选择门店"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      if (this.addHotelModal.elongName.length==0) {
        this.$Notice.error({
          title: "添加门店失败",
          desc: "请填写名称"
        });
        this.$refs.addHotelModal.buttonLoading = false;
        return;
      }
      let resp = (await API.omsAPI[this.env].ota.addHotel(
        this.addHotel.selectedHotel.chainId,
        this.username,
        this.token
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$refs.addHotelModal.buttonLoading = false;
        this.$Notice.error({
          title: "添加门店失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "添加门店成功"
        });
        this.addHotel.display = false;
        this.refreshTable();
        this.resetAddHotel();
      }
    },
    cancelAddHotel() {
      this.resetAddHotel();
    },
    async queryHotelProvinces() {
      let resp = (await API.omsAPI[this.env].ota.queryHotelProvinces(
        this.channelId,
        this.token
      )).data;

      if (resp.status==false) {
        this.$Notice.error({
          title: resp.msg
        });
        return;
      }

      resp.forEach(prov => {
        prov.label = prov.province;
        prov.value = prov.province;
        prov.loading = false;
        prov.children = [];
      })
      this.provCityList = resp;
    },
    resetTabPane() {
      this.hotelList = Object.assign({}, this.hotelList, {
        form: {
          hotel: '',
          keyword: '',
        },
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      })
      this.roomTypeList = Object.assign({}, this.roomTypeList, {
        form: {
          dockingStatus: 'S00',
          hotel: '',
        },
        data: [],
        count: 0,
        page: 1,
        pageSize: 10
      })
    },
    resetAddHotel() {
      this.addHotel = Object.assign({}, this.addHotel, {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: [],
        displayData: [],
        selectedHotel: {},
        elongName: '',
        form: {
          city: [],
          keyword: ''
        }
      });
    },
    refreshTable() {
      this.resetTabPane();
      
      this.queryHotelProvinces();

      this[this.currTabName].page = 1;
      this.queryOtaList();
    }
  }
}
</script>

<style lang="scss" scoped>
.add-wrapper {
  margin-top: 20px;
}

.tabs {
  margin-top: 20px;
}

.table-wrapper {
  margin-top: 20px;
}
.text-align-center {
  text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/pages/ota/elong-list.vue